import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useDispatch, useSelector} from 'react-redux';
import relationshipService from '../../services/relationship/RelationshipService';
import * as snackbarsActions from '../../actions/snackbars';
import {captureError} from '../../utils/log';
import FavoriteRelationshipView from './FavoriteRelationshipView';
import {recordGAEvent} from '../../utils/analytics';

function FavoriteRelationshipContainer(props) {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isFavorite, setIsFavorite] = useState(false);

  React.useEffect(() => {
    relationshipService.isFavoriteRelationship(props.clientId, props.subcontractorId, user.id)
      .then(response => setIsFavorite(response))
      .catch(error => {
        captureError('Error while fetching relationship favorite state', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      })
      .finally(() => setLoading(false));
  }, []);

  function switchFavoriteRelationshipState() {
    if (loading) {
      return;
    }

    setLoading(true);

    recordGAEvent('Organisation details', 'Favorite', isFavorite ? 'Remove' : 'Add');

    relationshipService.switchFavoriteRelationshipState(props.clientId, props.subcontractorId, user.id, !isFavorite)
      .then(() => {
        dispatch(snackbarsActions.addSuccess(
          <Translate
            value={`favoriteRelationship.message.${isFavorite ? 'remove' : 'add'}`}
            organisationName={props.organisationName}
          />
        ));
        setIsFavorite(current => !current);
      })
      .catch(error => {
        captureError('Error while switching relationship favorite state', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      })
      .finally(() => setLoading(false));
  }

  return (
    <FavoriteRelationshipView
      loading={loading}
      isFavorite={isFavorite}
      onSwitch={switchFavoriteRelationshipState}
    />
  );
}

FavoriteRelationshipContainer.propTypes = {
  clientId: PropTypes.number.isRequired,
  subcontractorId: PropTypes.number.isRequired,
  organisationName: PropTypes.string.isRequired
};

export default FavoriteRelationshipContainer;
